import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useToast } from '@shared/hooks/use-toast';

import { Filters } from '../../models/Filters';
import { useExportProductsExcel } from '../../hooks/useExportProductsExcel';

interface Props {
  /** Todos los filtros (searchTerm, event_ids, sortBy, sortDirection, page, limit…) */
  filters: Filters;
}

export const DownloadExcelButton: React.FC<Props> = ({ filters }) => {
  const { t } = useTranslation('productsModule');
  const { toast } = useToast();
  const exportMutation = useExportProductsExcel();

  const handleDownload = () => {
    exportMutation.mutate(filters, {
      onSuccess: (url) => {
        if (url) {
          // Forzar descarga directa
          const link = document.createElement('a');
          link.href = url;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast({
            title: t('toasts.export_success'),
            description: t('buttons.download_excel'),
          });
        } else {
          toast({
            title: t('toasts.error_title'),
            description: t('toasts.export_error'),
            variant: 'destructive',
          });
        }
      },
      onError: (error: any) =>
        toast({
          title: t('toasts.error_title'),
          description: error?.message ?? t('toasts.export_error'),
          variant: 'destructive',
        }),
    });
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={exportMutation.isPending}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 !text-icons transition-opacity duration-200 ${
        exportMutation.isPending ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="download-excel-button"
    >
      <FontAwesomeIcon icon={faFileArrowDown} className="!text-icons" />
    </Button>
  );
};
